import { useEffect, useState } from "react";
import { LogOut, BookOpen, ArrowLeft, CheckCircle, Briefcase } from "react-feather";
import { getSession } from "../utils/authSession";
import { getUser } from "../api/LoginApi";
import { useTranslation } from "react-i18next";
import "./Header.css";

import { clearProjectAuth } from "../utils/projectAuthSession";

export default function Header({ onLogout, onProjects, onBack, onPortal }) {
    const { t } = useTranslation();

    const [loggedOut, setLoggedOut] = useState(false);
    const [closingLogout, setClosingLogout] = useState(false);

    const [portalWarningOpen, setPortalWarningOpen] = useState(false);

    const session = getSession();
    const isLoggedIn = !!session;

    const userEmail = session?.email || "";

    const [user, setUser] = useState(null);

    const canAccessPortal =
        user?.role === "owner" ||
        user?.role === "admin";

    useEffect(() => {

        if (!session?.email) return;

        getUser(session.userId, session.email)
            .then(setUser)
            .catch(console.error);

    }, [session?.userId, session?.email]);

    function closeLogoutModal() {
        setClosingLogout(true);

        setTimeout(() => {
            setLoggedOut(false);

            if (onLogout) {
                onLogout();
            } else {
                window.location.href = "/";
            }
        }, 220);
    }

    function handlePortalClick() {
        setPortalWarningOpen(true);
    }

    function cancelPortalNavigation() {
        setPortalWarningOpen(false);
    }

    function confirmPortalNavigation() {
        setPortalWarningOpen(false);

        if (onPortal) {
            onPortal();
        } else {
            window.location.href = "/ai-4signs?page=portal";
        }
    }

    function handleLogout() {
        clearProjectAuth();

        // Portal session
        localStorage.removeItem("ai4signs_portal_auth");

        // Existing session
        localStorage.removeItem("localUserEmail");
        localStorage.removeItem("lastUsedEmail");
        localStorage.removeItem("userVerified");

        setClosingLogout(false);
        setLoggedOut(true);

        setTimeout(() => {
            closeLogoutModal();
        }, 1800);
    }

    return (
        <>
            <header className="assistant-header">
                <div className="assistant-container assistant-header-inner">
                    <div className="assistant-title">
                        {onBack && (
                            <button
                                className="assistant-back"
                                onClick={onBack}
                                aria-label="Back"
                            >
                                <ArrowLeft size={18} />
                            </button>
                        )}

                        <div
                            className="assistant-logo"
                            onClick={() => {
                                window.location.href = "/";
                            }}
                        >
                            H
                        </div>

                        <div className="assistant-title-text">

                            <h2>{t("assistant.title")}</h2>

                            {userEmail && (
                                <small>
                                    {userEmail}
                                </small>
                            )}

                        </div>
                    </div>

                    <div className="assistant-actions">
                        {isLoggedIn && onProjects && (
                            <button
                                className="assistant-action-btn"
                                onClick={onProjects}
                                aria-label="My Projects"
                            >
                                <BookOpen size={18} />
                                <span>Projects</span>
                            </button>
                        )}

                        {isLoggedIn && onPortal && canAccessPortal && (
                            <button
                                className="assistant-action-btn"
                                onClick={handlePortalClick}
                                aria-label="Portal"
                            >
                                <Briefcase size={18} />
                                <span>Portal</span>
                            </button>
                        )}

                        <button
                            className="assistant-action-btn"
                            onClick={handleLogout}
                            aria-label="Logout"
                        >
                            <LogOut size={18} />
                            <span>Logout</span>
                        </button>
                    </div>
                </div>
            </header>

            {loggedOut && (
                <div className="logout-modal-backdrop" onClick={closeLogoutModal}>
                    <div
                        className={`logout-modal ${closingLogout ? "closing" : ""}`}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="logout-icon">
                            <CheckCircle size={34} />
                        </div>

                        <h3>You’re logged out</h3>
                        <p>Your session has been safely closed.</p>
                    </div>
                </div>
            )}

            {portalWarningOpen && (
                <div className="portal-warning-backdrop" onClick={cancelPortalNavigation}>
                    <div
                        className="portal-warning-modal"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="portal-warning-icon">
                            <Briefcase size={30} />
                        </div>

                        <h3>Open Company Portal?</h3>

                        <p>
                            Any unsaved project setup or current page progress may be lost
                            if you continue.
                        </p>

                        <div className="portal-warning-actions">
                            <button
                                className="portal-warning-btn secondary"
                                onClick={cancelPortalNavigation}
                            >
                                Cancel
                            </button>

                            <button
                                className="portal-warning-btn primary"
                                onClick={confirmPortalNavigation}
                            >
                                Continue
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </>
    );
}